import { render, staticRenderFns } from "./rewardSpinsMasterEdit.vue?vue&type=template&id=8e981556&scoped=true&"
import script from "./rewardSpinsMasterEdit.vue?vue&type=script&lang=js&"
export * from "./rewardSpinsMasterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e981556",
  null
  
)

export default component.exports